import { IRecord, IRecords } from '@/models/IRecord';
import { Chip } from '@destination/components';
import ModelAttributeCard from '../../details/ModelAttributeCard';
import FunctionalityRecordDetail from './FunctionalityRecordDetail';

export interface IFunctionalityRecordsList {
  records?: IRecords;
  'data-testid'?: string;
}

export default function FunctionalityRecordsList({
  records,
  'data-testid': dataTestId
}: IFunctionalityRecordsList) {
  if (!records) return null;
  const EqualChip = ({
    label,
    width = 120
  }: {
    label: string;
    width?: number;
  }) => {
    return (
      <div className={`w-[${width}px]`}>
        <Chip label={label} className="mr-4" />
      </div>
    );
  };

  const titleComponent = (key: string, record: IRecord) => (
    <div className="flex items-center w-full">
      <EqualChip label={record.type} />
      <div className="tw-text-base">{key}</div>
    </div>
  );

  const mustShowBody = (record: IRecord) => {
    return record.type != 'boolean';
  };

  return (
    <div data-testid={dataTestId}>
      {Object.keys(records).map(key => {
        const record: IRecord = records[key] as IRecord;
        return (
          <ModelAttributeCard
            variant="LIGHT"
            key={key}
            title={titleComponent(key, records[key] as IRecord)}
          >
            {mustShowBody(record) && (
              <div className="p-3 bg-slate-50">
                <FunctionalityRecordDetail
                  name={key}
                  record={record as IRecord}
                  records={records}
                />
              </div>
            )}
          </ModelAttributeCard>
        );
      })}
    </div>
  );
}
